module.exports = __webpack_public_path__ + "static/media/kiwi.325dabb3.svg";